import React from 'react';
export const RootBoxEffectContext = React.createContext(null);
//# sourceMappingURL=root-box-effect-context.js.map